<template>
  <div class="err403">
    <div class="err403__card">
      <div class="err403__icon">
        <i class="material-icons-round">no_encryption</i>
      </div>
      <div class="err403__code">403</div>
      <h2 class="err403__title">접근 권한이 없습니다</h2>
      <p class="err403__desc">
        죄송합니다. 이 페이지에 접근할 수 있는 권한이 없습니다.<br />
        페이지 접근 권한이 필요한 경우 관리자에게 문의하세요.
      </p>

      <div class="err403__alert">
        <div><span class="err403__alert-label">요청한 페이지</span><span>{{ requestedPath || '알 수 없음' }}</span></div>
        <div><span class="err403__alert-label">현재 역할</span><span>{{ roleName || '역할 없음' }}</span></div>
      </div>

      <div class="err403__actions">
        <ABtn icon="arrow_back" @click="goBack">이전 페이지</ABtn>
        <ABtn kind="primary" icon="home" @click="goToDashboard">대시보드로 돌아가기</ABtn>
      </div>

      <div class="err403__help">
        <div class="err403__help-label">
          <i class="material-icons-round">info</i> 도움말
        </div>
        <ul>
          <li>관리자에게 페이지 접근 권한을 요청하세요.</li>
          <li>잘못된 링크로 접근했을 수 있습니다. URL을 확인하세요.</li>
          <li>로그인 정보가 변경되었다면 다시 로그인해보세요.</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ABtn from "@/components/Pineapple/ABtn.vue";

export default {
  name: "Error403",
  components: { ABtn },
  data() {
    return { requestedPath: "" };
  },
  computed: {
    ...mapGetters("auth", ["getRoleName"]),
    roleName() { return this.getRoleName || "권한 없음"; },
  },
  mounted() {
    this.requestedPath = this.$route.query.from || "";
  },
  methods: {
    goToDashboard() { this.$router.push({ name: "Sales" }); },
    goBack() { this.$router.go(-1); },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.err403 {
  min-height: 100vh;
  background: $p-bg;
  display: grid;
  place-items: center;
  padding: 32px 16px;

  &__card {
    background: $p-panel;
    border: 1px solid $p-line;
    border-radius: $p-radius-xl;
    padding: 40px 36px;
    max-width: 520px;
    width: 100%;
    text-align: center;
    box-shadow: $p-shadow-md;
  }

  &__icon {
    width: 72px;
    height: 72px;
    border-radius: 18px;
    background: $p-err-soft;
    color: $p-err;
    display: inline-grid;
    place-items: center;
    margin-bottom: 14px;

    > i { font-size: 36px; }
  }

  &__code {
    font-family: $p-font-mono;
    font-size: 64px;
    font-weight: 900;
    color: $p-err;
    letter-spacing: -0.04em;
    line-height: 1;
    margin-bottom: 12px;
  }

  &__title {
    font-size: 20px;
    font-weight: 800;
    color: $p-ink;
    margin: 0 0 12px;
    letter-spacing: -0.02em;
  }

  &__desc {
    font-size: 13px;
    color: $p-ink-mid;
    line-height: 1.7;
    margin: 0 0 18px;
  }

  &__alert {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 14px 16px;
    background: $p-warn-soft;
    border-left: 3px solid $p-warn;
    border-radius: $p-radius-md;
    text-align: left;
    font-size: 12px;
    color: $p-ink2;
    margin-bottom: 22px;

    > div {
      display: flex;
      gap: 8px;
    }
  }

  &__alert-label {
    color: $p-warn;
    font-weight: 800;
    min-width: 90px;
    font-size: 11px;
    letter-spacing: 0.02em;
  }

  &__actions {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-bottom: 24px;
  }

  &__help {
    text-align: left;
    background: $p-panel-alt;
    border: 1px solid $p-line-soft;
    border-radius: $p-radius-md;
    padding: 14px 16px;
  }

  &__help-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: $p-point-deep;
    margin-bottom: 8px;

    > i { font-size: 14px !important; }
  }

  ul {
    margin: 0;
    padding-left: 16px;
    font-size: 12px;
    color: $p-ink-mid;
    line-height: 1.7;
  }
}
</style>
